import { gql } from '@apollo/client'

export const UpdateSelfReflection = gql`
  mutation UpdateSelfreflectionQuestion($input: SelfreflectionInput!) {
    updateSelfreflectionQuestion(selfreflectionQuestion: $input) {
      id
      textId
      value
      comment
      position
      type
      meetingId
      subItems {
        id
        textId
        value
        position
      }
    }
  }
`

export const UpdateSelfReflectionBoolean = gql`
  mutation UpdateSelfreflectionQuestionBoolean($input: SelfreflectionQuestionBooleanInput!) {
    updateSelfreflectionQuestionBoolean(selfreflectionQuestionBoolean: $input) {
      id
      textId
      value
      position
    }
  }
`

export default {
  UpdateSelfReflection,
  UpdateSelfReflectionBoolean,
}
